import { Ordering } from '@wix/comments-ooi-client/controller';
import { isQuestion } from '@wix/communities-forum-client-commons';

export const CommentsOrderingMap = {
  latest_first: Ordering.LATEST_FIRST,
  oldest_first: Ordering.OLDEST_FIRST,
  most_votes_first: Ordering.MOST_VOTES_FIRST,
  least_votes_first: Ordering.LEAST_VOTES_FIRST,
  most_reactions_first: Ordering.MOST_REACTIONS_FIRST,
};

const PAGINATION_CONFIG = {
  replyShowMoreLimit: 8,
  ordering: Ordering.LATEST_FIRST,
  initialPage: {
    offset: 0,
    commentLimit: 20,
    replyLimit: 3,
  },
  pagination: {
    commentLimit: 20,
    replyLimit: 3,
  },
  maxPagesBeforeDrop: {
    commentPages: 2,
    replyPages: 4,
  },
};
const PAGINATION_CONFIG_VOTES = { ...PAGINATION_CONFIG, ordering: Ordering.MOST_VOTES_FIRST };

export const getPaginationConfig = (post, commentsOrdering) => {
  return {
    ...(isQuestion(post?.postType) ? PAGINATION_CONFIG_VOTES : PAGINATION_CONFIG),
    ...(commentsOrdering ? { ordering: CommentsOrderingMap[commentsOrdering] } : {}),
  };
};
